/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a77c7787f980fdb0a9bf8aad01cf287>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _zoomIn = _interopRequireDefault(require("@atlaskit/icon/core/zoom-in"));
var _zoomIn2 = _interopRequireDefault(require("@atlaskit/icon/glyph/media-services/zoom-in"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Migration Icon component for ZoomInIcon.
 * This component is ZoomInIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesZoomInIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming in of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const ZoomInIcon = props => /*#__PURE__*/_react.default.createElement(_zoomIn.default, Object.assign({
  LEGACY_fallbackIcon: _zoomIn2.default
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
ZoomInIcon.Name = 'ZoomInIconMigration';
var _default = exports.default = ZoomInIcon;